import { onNewMailNotificationClicked } from 'owa-header-app-notifications';
import { orchestrator } from 'satcheljs';
import selectFolderAndRow from './selectFolderAndRow';
import { getUserConfiguration } from 'owa-session-store';
export default orchestrator(onNewMailNotificationClicked, function (message) {
    var notification = message.notification;
    var rowId = getUserConfiguration().UserOptions.GlobalListViewTypeReact === 1 /* Message */
        ? notification.ItemId
        : notification.ConversationId;
    selectFolderAndRow('inbox', rowId);
});
//# sourceMappingURL=onNewMailNotificationClicked.js.map